import Bean from './Bean';

export default class Flight extends Bean {

}